(function() {
  exports.Form = function(handler, type, data) {
    var cls, self;
    if (data == null) {
      data = {};
    }
    self = this;
    this.getHandler = function() {
      return handler;
    };
    this.setEditing = function() {
      return this.editing(true);
    };
    this.editing = ko.observable(false);
    type = type.replace(' ', '');
    cls = App.loadClass("grower::viewmodels/machinery/" + type);
    this.layer = new cls(this, data);
    return this;
  };

}).call(this);
